function productDetails() {
	const panelWrap = document.getElementById('productDetails');

	if (!panelWrap) return;

	const openAllAccordionPanels = () => {
		const triggers = panelWrap.querySelectorAll('[data-toggle="collapse"]');
		Array.from(triggers).forEach(trigger =>
			trigger.setAttribute('aria-expanded', true),
		);
	};

	if (window.od.device() !== 'xs') {
		openAllAccordionPanels();
	}

	panelWrap.addEventListener('click', e => {
		const trigger = e.target.closest('[data-toggle="collapse"]');
		if (trigger && window.od.device() !== 'xs') {
			e.stopPropagation();
		}
	});
}

export default productDetails;
